import React from "react";
import PropTypes from "prop-types";
import "./common.css";
import fallbackLogo from "assets/images/logos/logo.jpeg";

const PageLoader = ({ text = "लोड होत आहे...", subtext = "भारतीय जनता पक्ष नागरिक सेवा मंच" }) => {
  return (
    <div className="page-loader-overlay">
      <div className="loader-container">
        
        {/* Outer Spinning Glow Ring & Emblem */}
        <div className="loader-ring-wrapper">
          <div className="loader-ring"></div>
          <div className="loader-ring-inner"></div>
          <div className="loader-emblem">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/1/1e/Bharatiya_Janata_Party_logo.svg"
              alt="BJP Logo"
              onError={(e) => {
                e.target.onerror = null;
                if (e.target.src !== fallbackLogo) {
                  e.target.src = fallbackLogo;
                }
              }}
            />
          </div>
        </div>

        {/* Text */}
        <h4 className="loading-text">{text}</h4>
        <p className="loading-subtext">{subtext}</p>

        {/* Animated Progress Bar */}
        <div className="loading-bar">
          <div className="loading-bar-fill"></div>
        </div>

      </div>
    </div>
  );
};

PageLoader.propTypes = {
  text: PropTypes.string,
  subtext: PropTypes.string,
};

export default PageLoader;
